module.exports = "/shifts/components/calendarHeader/calendarPrintHeader-fc0045.html";